import React from 'react';

// Same stroke + opacity as the hero and Über-mich construction lines.
const STROKE = '#5e2a56';
const OPACITY = 0.06;
function boltCircle(cx: number, cy: number, r: number, holes: number, holeR: number) {
  return Array.from({
    length: holes
  }, (_, i) => {
    const a = i / holes * Math.PI * 2 - Math.PI / 2;
    return <circle key={i} cx={cx + Math.cos(a) * r} cy={cy + Math.sin(a) * r} r={holeR} data-id="element-471" data-mp="11yysc8najd4g" />;
  });
}
function ticks(y: number, from: number, to: number, step: number) {
  const out: string[] = [];
  for (let x = from; x <= to; x += step) out.push(`M${x} ${y - 3}V${y + 3}`);
  return out.join('');
}

/** Very faint drafting geometry behind the Projekte page (wide screens only). */
export function ProjekteBlueprint() {
  return <svg className="pointer-events-none absolute inset-x-0 top-0 hidden h-[1400px] w-full lg:block" viewBox="0 0 1360 1400" preserveAspectRatio="xMidYMin slice" aria-hidden="true" data-id="element-472" data-mp="1kv8cndosczww">
      <g fill="none" stroke={STROKE} strokeOpacity={OPACITY} strokeWidth="1" data-id="element-473" data-mp="2df6zkndo3cmg">
        {/* Gear-like ring cluster to the right of the heading */}
        <circle cx="1120" cy="250" r="250" data-id="element-474" data-mp="2vllik4e6mllu" />
        <circle cx="1120" cy="250" r="190" strokeDasharray="24 6 3 6" data-id="element-475" data-mp="2vipjgcqllqvt" />
        <circle cx="1120" cy="250" r="120" strokeDasharray="2 6" data-id="element-476" data-mp="3aahxmlenoyvy" />
        <circle cx="1120" cy="250" r="44" data-id="element-477" data-mp="35igce9zifxts" />
        {boltCircle(1120, 250, 155, 8, 9)}
        <path d="M820 250H1360M1120 0V560" strokeDasharray="24 6 3 6" data-id="element-478" data-mp="3ja4o4c5ukka8" />

        {/* Measuring rail under the tabs */}
        <line x1="0" y1="430" x2="1360" y2="430" strokeDasharray="2 6" data-id="element-479" data-mp="3ec37dxvw8x1x" />
        <path d={ticks(430, 16, 1344, 32)} data-id="element-480" data-mp="3t8keue0yprj7" />

        {/* Sweeping arcs and rays */}
        <path d="M-60 40 A520 520 0 0 1 420 820" data-id="element-481" data-mp="3t682qhhvybe2" />
        <path d="M-40 1300 A760 760 0 0 1 1400 1300" data-id="element-482" data-mp="3oaj0g6ehege2" />
        <path d="M1360 0 L760 720" strokeDasharray="1 5" data-id="element-483" data-mp="1yujji34mfmnv" />
        <path d="M0 620 L680 520 L1360 620" strokeDasharray="1 5" data-id="element-484" data-mp="1yv32ln60ch3h" />

        {/* Verticals framing the content */}
        <line x1="112" y1="0" x2="112" y2="1400" strokeDasharray="2 6" data-id="element-485" data-mp="1txaylus394ix" />
        <line x1="1248" y1="560" x2="1248" y2="1400" strokeDasharray="2 6" data-id="element-486" data-mp="2jkx8a9xupmz1" />
      </g>
    </svg>;
}